var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 48,
    viewBox: "0 0 227 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7844_2634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4002 17.6476L57.0245 0H43.6407L33.479 10.1751C27.7638 15.8978 18.4925 15.8978 12.7772 10.1751L2.61555 0H0L17.6243 17.6476C23.6401 23.6712 33.39 23.6712 39.4058 17.6476",
    fill: "#6941E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4001 2.84189L42.2383 0H14.7861L17.6243 2.84189C23.64 8.86557 33.3899 8.86557 39.4057 2.84189",
    fill: "#6941E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4789 25.042C28.5817 29.9457 21.0745 30.6422 15.4316 27.1428L19.4162 34.0525C25.4431 38.4769 33.952 37.9642 39.4057 32.5089L39.5114 32.4031L57.7924 0.702118L33.4845 25.042H33.4789Z",
    fill: "#6941E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5081 35.8746L33.4791 39.909C31.1418 42.2494 28.2146 43.6257 25.1816 44.0548L26.6898 46.6682C27.7081 48.4402 30.2625 48.4402 31.2809 46.6682L37.5025 35.8746H37.5081Z",
    fill: "#6941E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.677 20.5173C146.677 15.4075 142.525 11.2505 137.422 11.2505H123.309C118.201 11.2505 114.055 15.4019 114.055 20.5173V27.4883C114.055 32.6037 118.201 36.7551 123.309 36.7551H137.422C142.525 36.7551 146.677 32.5981 146.677 27.4883H140.488V29.773C140.488 30.4082 139.976 30.9209 139.342 30.9209H121.395C120.761 30.9209 120.249 30.4082 120.249 29.773V18.2382C120.249 17.603 120.761 17.0903 121.395 17.0903H139.342C139.976 17.0903 140.488 17.603 140.488 18.2382V20.5229H146.677V20.5173Z",
    fill: "#6941E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.308 29.706H214.464L219.328 36.7495H226.857L221.409 28.8646C224.448 27.4381 226.557 24.3455 226.557 20.768V20.1774C226.557 15.2514 222.556 11.2449 217.636 11.2449H195.12V36.7439H201.308V29.7005V29.706ZM201.308 17.0847H219.222C219.857 17.0847 220.369 17.5974 220.369 18.2326V22.7239C220.369 23.3592 219.857 23.8718 219.222 23.8718H201.308V17.0847Z",
    fill: "#6941E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.3 34.1249L167.985 12.6826C167.478 11.7966 166.538 11.2561 165.52 11.2561H156.732C155.163 11.2561 153.889 12.5322 153.889 14.1036V36.7551H160.077V14.2095C160.077 13.4293 161.112 13.1507 161.496 13.8305L173.839 35.323C174.346 36.209 175.286 36.7495 176.304 36.7495H185.064C186.633 36.7495 187.908 35.4734 187.908 33.902V11.2505H181.719V33.7405C181.719 34.5206 180.684 34.7992 180.295 34.1194",
    fill: "#6941E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.928 11.2505L94.9331 34.3255C94.5492 35.2115 93.297 35.2115 92.9131 34.3255L82.9183 11.2505H76.168L86.4743 35.0332C86.9251 36.0753 87.9491 36.7495 89.0843 36.7495H98.7674C99.9027 36.7495 100.927 36.0753 101.377 35.0332L111.678 11.2505H104.928Z",
    fill: "#6941E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7844_2634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 226.857,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a248d5f0fd9abb2a75015071670e6671.svg";
export { ForwardRef as ReactComponent };